/* ============================================================
   LAO : Club des Testeurs : formulaire multi-étapes inline.
   Navigation entre écrans + validation + soumission Klaviyo onsite.
   Clé publique Klaviyo (company_id) = RkCp6D (identique au diagnostic).
   ============================================================ */
(function () {
  class ClubTesteursForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-ct-form]');
      this.screens = Array.from(this.querySelectorAll('.ct__screen'));
      this.nav = this.querySelector('[data-ct-nav]');
      this.prevBtn = this.querySelector('[data-ct-prev]');
      this.nextBtn = this.querySelector('[data-ct-next]');
      this.bar = this.querySelector('[data-ct-bar]');
      this.stepEl = this.querySelector('[data-ct-step]');
      this.totalEl = this.querySelector('[data-ct-total]');
      this.progress = this.querySelector('[data-ct-progress]');
      this.noteEl = this.querySelector('[data-ct-note]');
      this.listId = (this.dataset.listId || '').trim();
      this.cloudName = (this.dataset.cloudName || '').trim();
      this.uploadPreset = (this.dataset.uploadPreset || '').trim();
      this.sheetWebhookUrl = (this.dataset.sheetWebhookUrl || '').trim();
      // Étapes navigables (hors écran de confirmation)
      this.steps = this.screens.filter(function (s) { return s.dataset.screen !== 'done'; });
      this.pos = 0;
      this.data = { nature: '', epaisseur: '', abimes: '' };
      this.bind();
      if (this.totalEl) this.totalEl.textContent = this.steps.length;
      this.show(0);
    }

    bind() {
      var self = this;
      // Pastilles (choix unique)
      this.querySelectorAll('[data-ct-pill]').forEach(function (group) {
        var key = group.getAttribute('data-ct-pill');
        group.querySelectorAll('.ct__pill').forEach(function (b) {
          b.addEventListener('click', function () {
            group.querySelectorAll('.ct__pill').forEach(function (x) { x.classList.remove('is-active'); });
            b.classList.add('is-active');
            self.data[key] = b.dataset.value;
          });
        });
      });
      // Affiche le nom du fichier choisi
      this.querySelectorAll('input[type="file"][data-ct]').forEach(function (input) {
        var key = input.getAttribute('data-ct');
        var nameEl = self.querySelector('[data-ct-filename="' + key + '"]');
        input.addEventListener('change', function () {
          input.classList.remove('is-error');
          var box = input.closest('.ct__upload');
          if (box) box.classList.remove('is-error');
          if (nameEl) nameEl.textContent = (input.files && input.files[0]) ? input.files[0].name : 'Aucun fichier sélectionné';
        });
      });
      // Nettoie l'erreur quand on tape
      this.querySelectorAll('[data-ct]:not([type="file"])').forEach(function (el) {
        el.addEventListener('input', function () { el.classList.remove('is-error'); });
      });
      this.nextBtn.addEventListener('click', function () { self.next(); });
      this.prevBtn.addEventListener('click', function () { self.prev(); });
    }

    show(pos) {
      if (pos < 0) pos = 0;
      if (pos > this.steps.length - 1) pos = this.steps.length - 1;
      this.pos = pos;
      var active = this.steps[pos];
      this.screens.forEach(function (s) { s.classList.toggle('is-active', s === active); });
      this.prevBtn.style.visibility = pos === 0 ? 'hidden' : 'visible';
      this.nextBtn.textContent = (pos === this.steps.length - 1) ? 'Envoyer ma candidature' : 'Continuer →';
      this.nextBtn.classList.toggle('ct__btn--final', pos === this.steps.length - 1);
      this.updateGauge();
      this.clearError();
      this.scrollTop();
    }

    updateGauge() {
      var total = this.steps.length;
      var done = this.pos + 1;
      var pct = total ? Math.round(done / total * 100) : 0;
      if (this.bar) this.bar.style.width = pct + '%';
      if (this.stepEl) this.stepEl.textContent = done;
    }

    val(key) { var el = this.querySelector('[data-ct="' + key + '"]'); return el ? (el.value || '').trim() : ''; }
    file(key) { var el = this.querySelector('input[type="file"][data-ct="' + key + '"]'); return (el && el.files && el.files[0]) ? el.files[0] : null; }
    errEl() { return this.querySelector('[data-ct-error="' + this.steps[this.pos].dataset.screen + '"]'); }
    clearError() {
      this.querySelectorAll('.ct__error').forEach(function (e) { e.classList.remove('is-shown'); e.textContent = ''; });
    }
    showError(msg, fieldKey) {
      var e = this.errEl();
      if (e) { e.textContent = msg; e.classList.add('is-shown'); }
      if (fieldKey) {
        var f = this.querySelector('[data-ct="' + fieldKey + '"]');
        if (f) { f.classList.add('is-error'); f.focus(); }
      }
    }
    showNote(msg) { if (this.noteEl) { this.noteEl.textContent = msg; this.noteEl.classList.add('is-shown'); } }

    validateStep() {
      var step = this.steps[this.pos].dataset.screen;
      if (step === '1') {
        if (!this.val('firstname')) { this.showError('Merci d’indiquer votre prénom.', 'firstname'); return false; }
        if (!this.val('lastname')) { this.showError('Merci d’indiquer votre nom.', 'lastname'); return false; }
        var email = this.val('email');
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { this.showError('Merci d’indiquer un e-mail valide.', 'email'); return false; }
        if (!this.val('phone')) { this.showError('Merci d’indiquer votre numéro de téléphone.', 'phone'); return false; }
        return true;
      }
      if (step === '2') {
        if (!this.val('age')) { this.showError('Merci d’indiquer votre âge.', 'age'); return false; }
        if (!this.val('street')) { this.showError('Merci d’indiquer votre adresse.', 'street'); return false; }
        if (!this.val('zip')) { this.showError('Merci d’indiquer votre code postal.', 'zip'); return false; }
        if (!this.val('city')) { this.showError('Merci d’indiquer votre ville.', 'city'); return false; }
        return true;
      }
      if (step === '3') {
        if (!this.data.epaisseur) { this.showError('Merci de choisir l’épaisseur de vos cheveux.'); return false; }
        if (!this.data.nature) { this.showError('Merci de choisir la nature de vos cheveux.'); return false; }
        if (!this.data.abimes) { this.showError('Merci d’indiquer si vos cheveux sont abîmés.'); return false; }
        var consent = this.querySelector('[data-ct="consent"]');
        if (consent && !consent.checked) { this.showError('Merci d’accepter le traitement de vos données.'); return false; }
        return true;
      }
      return true;
    }

    next() {
      if (!this.validateStep()) return;
      if (this.pos < this.steps.length - 1) { this.show(this.pos + 1); return; }
      // Dernière étape -> soumission
      this.submit();
    }
    prev() { if (this.pos > 0) this.show(this.pos - 1); }

    collect() {
      var indic = this.val('indicatif');
      var phoneNum = this.val('phone');
      var phoneDigits = phoneNum.replace(/\D/g, '').replace(/^0+/, '');
      var phoneE164 = (phoneNum && indic) ? (indic + phoneDigits) : '';
      var street = this.val('street'), zip = this.val('zip'), city = this.val('city');
      var typeCheveu = [this.data.epaisseur, this.data.nature, (this.data.abimes === 'Oui' ? 'abîmés' : 'non abîmés')]
        .filter(Boolean).join(', ');
      return {
        firstname: this.val('firstname'),
        lastname: this.val('lastname'),
        email: this.val('email'),
        phone: phoneE164 || ((indic ? indic + ' ' : '') + phoneNum),
        phoneE164: phoneE164,
        age: this.val('age'),
        ville: city,
        adresse: [street, zip, city].filter(Boolean).join(', '),
        street: street, zip: zip, city: city,
        epaisseur: this.data.epaisseur,
        nature: this.data.nature,
        abimes: this.data.abimes,
        typeCheveu: typeCheveu,
        photoUrl: ''
      };
    }

    // Upload Cloudinary unsigned. Résout toujours (jamais de rejet) pour ne pas bloquer la soumission.
    uploadFile(fileObj) {
      var self = this;
      return new Promise(function (resolve) {
        if (!fileObj || !self.cloudName || !self.uploadPreset) { resolve(''); return; }
        var fd = new FormData();
        fd.append('file', fileObj);
        fd.append('upload_preset', self.uploadPreset);
        fetch('https://api.cloudinary.com/v1_1/' + self.cloudName + '/auto/upload', { method: 'POST', body: fd })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (json) { resolve(json && json.secure_url ? json.secure_url : ''); })
          .catch(function () { resolve(''); });
      });
    }

    submit() {
      var self = this;
      this.nextBtn.disabled = true;
      this.nextBtn.textContent = 'Envoi en cours…';
      var p = this.collect();

      var photoFile = this.file('photo');
      if (photoFile && (!this.cloudName || !this.uploadPreset)) {
        this.showNote('Note : l’hébergement de la photo n’est pas encore configuré, votre candidature nous est tout de même transmise.');
      }

      this.uploadFile(photoFile)
        .then(function (url) { p.photoUrl = url || ''; })
        .catch(function () {})
        .then(function () {
          self.pushKlaviyo(p);
          self.pushEvent(p);
          self.subscribeToList(p);
          self.pushSheet(p);
          self.goDone();
        });
    }

    // Identification + event via l'objet onsite Klaviyo (klaviyo.identify / klaviyo.track).
    pushKlaviyo(p) {
      try {
        var k = window.klaviyo || window._learnq;
        if (!k || !p.email) return;
        var idAttrs = {
          '$email': p.email,
          '$first_name': p.firstname,
          '$last_name': p.lastname,
          'Age': p.age,
          'Ville': p.ville,
          'Adresse': p.adresse,
          'TypeCheveu': p.typeCheveu,
          'PhotoCheveux': p.photoUrl
        };
        if (p.phoneE164) idAttrs['$phone_number'] = p.phoneE164;
        // Compat des deux API : klaviyo.identify(...) sinon klaviyo.push(['identify', ...])
        if (typeof k.identify === 'function') { k.identify(idAttrs); }
        else { k.push(['identify', idAttrs]); }

        var eventProps = {
          Prenom: p.firstname,
          Nom: p.lastname,
          Email: p.email,
          Telephone: p.phone,
          Age: p.age,
          Ville: p.ville,
          Adresse: p.adresse,
          CodePostal: p.zip,
          Rue: p.street,
          Epaisseur: p.epaisseur,
          Nature: p.nature,
          Abimes: p.abimes,
          TypeCheveu: p.typeCheveu,
          PhotoCheveux: p.photoUrl,
          Source: 'Page Club des Testeurs'
        };
        if (typeof k.track === 'function') { k.track('Candidature Club Testeurs', eventProps); }
        else { k.push(['track', 'Candidature Club Testeurs', eventProps]); }
      } catch (e) {}
    }

    // Event traçable via l'API Client Events de Klaviyo (fiable, indépendant du chargement onsite).
    // C'est ce qui garantit un vrai event « Candidature Club Testeurs » avec ses propriétés (photo incluse).
    pushEvent(p) {
      if (!p.email) return;
      try {
        fetch('https://a.klaviyo.com/client/events/?company_id=RkCp6D', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                properties: {
                  Prenom: p.firstname,
                  Nom: p.lastname,
                  Telephone: p.phone,
                  Age: p.age,
                  Ville: p.ville,
                  Adresse: p.adresse,
                  CodePostal: p.zip,
                  Rue: p.street,
                  Epaisseur: p.epaisseur,
                  Nature: p.nature,
                  Abimes: p.abimes,
                  TypeCheveu: p.typeCheveu,
                  PhotoCheveux: p.photoUrl,
                  Source: 'Page Club des Testeurs'
                },
                metric: { data: { type: 'metric', attributes: { name: 'Candidature Club Testeurs' } } },
                profile: { data: { type: 'profile', attributes: {
                  email: p.email,
                  first_name: p.firstname,
                  last_name: p.lastname,
                  phone_number: p.phoneE164 || undefined
                } } }
              }
            }
          })
        }).catch(function () {});
      } catch (e) {}
    }

    // Abonnement direct à la liste « Club des testeurs ».
    // Ne s'exécute QUE si l'ID de liste est renseigné (réglage data-list-id de la section).
    // Tant qu'il est vide, on s'appuie sur l'event « Candidature Club Testeurs » (segment possible).
    subscribeToList(p) {
      var LISTE_ID_KLAVIYO = this.listId; // <- Brancher l'ID de la liste « Club des testeurs » ici (réglage section).
      if (!LISTE_ID_KLAVIYO) return;
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RkCp6D', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Candidature Club Testeurs',
                profile: { data: { type: 'profile', attributes: {
                  email: p.email,
                  first_name: p.firstname,
                  last_name: p.lastname,
                  phone_number: p.phoneE164 || undefined,
                  properties: { Age: p.age, Ville: p.ville, Adresse: p.adresse, CodePostal: p.zip, TypeCheveu: p.typeCheveu, Epaisseur: p.epaisseur, Nature: p.nature, Abimes: p.abimes, PhotoCheveux: p.photoUrl }
                } } }
              },
              relationships: { list: { data: { type: 'list', id: LISTE_ID_KLAVIYO } } }
            }
          })
        }).catch(function () {});
      } catch (e) {}
    }

    // Remontée vers un Google Sheet via webhook (Apps Script Web App).
    // POST text/plain pour éviter le preflight CORS. Ne s'exécute que si l'URL est renseignée.
    pushSheet(p) {
      var url = this.sheetWebhookUrl;
      if (!url) return;
      try {
        fetch(url, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({
            date: new Date().toISOString(),
            prenom: p.firstname,
            nom: p.lastname,
            email: p.email,
            telephone: p.phone,
            age: p.age,
            ville: p.ville,
            adresse: p.adresse,
            cp: p.zip,
            epaisseur: p.epaisseur,
            nature: p.nature,
            abimes: p.abimes,
            type_cheveu: p.typeCheveu,
            photo_url: p.photoUrl
          })
        }).catch(function () {});
      } catch (e) {}
    }

    goDone() {
      var done = this.screens.filter(function (s) { return s.dataset.screen === 'done'; })[0];
      this.screens.forEach(function (s) { s.classList.toggle('is-active', s === done); });
      if (this.nav) this.nav.style.display = 'none';
      if (this.progress) this.progress.style.display = 'none';
      if (this.noteEl) this.noteEl.classList.remove('is-shown');
      this.scrollTop();
    }

    scrollTop() {
      try {
        var wrap = this.querySelector('.ct__wrap') || this;
        var off = (window.innerWidth <= 749 ? 56 : 70);
        var y = wrap.getBoundingClientRect().top + window.pageYOffset - off;
        if (Math.abs(window.pageYOffset - y) > 2) window.scrollTo({ top: y, behavior: 'auto' });
      } catch (e) {}
    }
  }

  if (!customElements.get('club-testeurs-form')) customElements.define('club-testeurs-form', ClubTesteursForm);
})();
